import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  FOOTER_HEIGHT,
  HEADER_HEIGHT,
  MAX_PAGE_HEIGHT,
  MAX_PAGE_WIDTH,
  WEB_CONTENT_WIDTH,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  pageWrapper: {
    position: 'relative',
    height: MAX_PAGE_HEIGHT,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageContainerWrapper: {
    display: 'flex',
    maxWidth: MAX_PAGE_WIDTH,
    gap: theme.spacing(1),
    height: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT})`,

    [theme.breakpoints.down('md')]: {
      // width: MAX_PAGE_WIDTH,
      width: '100vw',
      gap: 0,
      height: `calc(${MAX_PAGE_HEIGHT} - ${FOOTER_HEIGHT})`,
    },
    width: '100%',
  },
  pageContainer: {
    position: 'relative',
    width: WEB_CONTENT_WIDTH,
    [theme.breakpoints.down('md')]: {
      // width: MAX_PAGE_WIDTH,
      width: '100vw',
    },
    borderRadius: '10px',
  },
  // headerMobileWrapper: {
  //   display: 'none',
  //   [theme.breakpoints.down('md')]: {
  //     display: 'block',
  //   },
  // },

  headerWrapper: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  pageHeaderWebWrapper: {
    display: 'block',
    borderRadius: '0 0 4px 4px',
    overflow: 'hidden',
    // boxShadow: '5px 5px 4px 0px #00000040',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.header.contrastText,
    '& svg': {
      height: '32px',
      width: '32px',
    },
  },

  title: {
    ...theme.mixins.appEllipsis,
  },
}));
